export const state = () => ({})

export const getters = {
  upcomingItems: (state, getters, rootState, rootGetters) => {
    const now = new Date()
    const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000)

    const tasks = (rootGetters['task/tasks']?.items || [])
      .filter(task => {
        if (!task.dueDate || task.status === 'done' || task.status === 'someday') return false
        const due = new Date(task.dueDate)
        return due >= now && due <= oneHourLater
      })
      .map(task => ({ ...task, _type: 'tasks', _time: new Date(task.dueDate) }))

    const events = (rootGetters['event/events'] || [])
      .filter(e => {
        const start = e.startDateTime ? new Date(e.startDateTime) : null
        return start && start >= now && start <= oneHourLater
      })
      .map(e => ({ ...e, _type: 'events', _time: new Date(e.startDateTime) }))

    return [...tasks, ...events].sort((a, b) => a._time - b._time)
  },

  gmailSyncNotificationCount: (state, getters, rootState, rootGetters) => {
    if (rootGetters['sync/gmailSyncNotificationDismissed']) return 0
    const status = rootGetters['sync/gmailSyncStatus']
    return status && status.unloadedEmails > 0 ? 1 : 0
  },

  aiRateLimitCount: (state, getters, rootState, rootGetters) =>
    rootGetters['ai/rateLimited'] ? 1 : 0,

  upcomingCount: (state, getters) =>
    getters.upcomingItems.length + getters.gmailSyncNotificationCount + getters.aiRateLimitCount,
}

export const mutations = {}
export const actions = {}
